import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

// Auth-aware primary CTA used by every "Sign up free" button on the marketing site.
// Registered users are sent into the app (the LaunchGate then holds anyone not yet
// admitted on the access-pending screen); guests go to the registration flow. This stops
// already-registered users from being invited to sign up again - and from creating
// duplicate accounts.
export function useRegisterAction(registerPath = '/register') {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isAuthed = !!user;
  const label = isAuthed ? 'Go to app' : 'Sign up free';
  const go = () => navigate(isAuthed ? '/app' : registerPath);
  return { isAuthed, label, go };
}
